
import React from 'react';

interface GenericPageProps {
  title: string;
  description?: string;
}

const GenericPage: React.FC<GenericPageProps> = ({ title, description }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <p className="text-gray-600">
        {description || 'This section is ready for your custom content and API integration.'}
      </p>

      <div className="mt-6 p-4 bg-blue-50 border border-blue-100 rounded-lg">
        <p className="text-sm text-blue-700">
          💡 <strong>Tip:</strong> You can customize this page by creating a new component for {title}.
        </p>
      </div>
    </div>
  );
};

export default GenericPage;